// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.TerritoriesTable .TerritoriesTable-component [class^=dist_numberSection] {
  display: none;
}
.TerritoriesTable .TerritoriesTable-component [class^=dist_tableHead] th:first-child {
  display: none;
}
.TerritoriesTable-title-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  margin-top: 12px;
}
.TerritoriesTable-title-wrapper svg {
  padding-left: 4px;
  padding-top: 2px;
}
.TerritoriesTable [class^=dist_tableBody],
.TerritoriesTable [class^=dist_tableHead] {
  grid-template-columns: 40px 320px minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) 285px;
}
.TerritoriesTable [class^=dist_tableBody] .favoriteContainer,
.TerritoriesTable [class^=dist_tableHead] .favoriteContainer {
  display: none;
}
.TerritoriesTable [class^=dist_tableBody]:hover .favoriteContainer,
.TerritoriesTable [class^=dist_tableHead]:hover .favoriteContainer {
  display: inherit;
}
.TerritoriesTable [class^=dist_tableBody] .favoriteContainer.isActive,
.TerritoriesTable [class^=dist_tableBody] .favoriteContainer:has(.FavoriteButton--isSaved),
.TerritoriesTable [class^=dist_tableHead] .favoriteContainer.isActive,
.TerritoriesTable [class^=dist_tableHead] .favoriteContainer:has(.FavoriteButton--isSaved) {
  display: inherit;
}
.TerritoriesTable [class^=dist_tableBody] {
  height: 64px;
}
.TerritoriesTable .NumberWithVariationTableCell {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.TerritoriesTable .NumberWithVariationTableCell-variation {
  font-size: 10px;
}
.TerritoriesTable .NumberWithVariationTableCell-variation-positive {
  color: var(--success);
}
.TerritoriesTable .NumberWithVariationTableCell-variation-negative {
  color: var(--danger);
}
.TerritoriesTable tr:hover .GenerateWinninAIReportButton-text {
  align-items: center;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/TerritoriesTable/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAXI;EACE,aAAA;AAaN;AATM;EACE,aAAA;AAWR;AALI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAON;AALM;EACE,iBAAA;EACA,gBAAA;AAOR;AAFE;;EAEE,mGAAA;AAIJ;AAFI;;EACE,aAAA;AAKN;AADM;;EACE,gBAAA;AAIR;AAAI;;;;EAEE,gBAAA;AAIN;AAAE;EACE,YAAA;AAEJ;AACE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,qBAAA;AADJ;AAIE;EACE,oBAAA;AAFJ;AAMI;EACE,mBAAA;EACA,aAAA;AAJN","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins.scss';\n\n.TerritoriesTable {\n  .TerritoriesTable-component {\n    [class^='dist_numberSection'] {\n      display: none;\n    }\n\n    [class^='dist_tableHead'] {\n      th:first-child {\n        display: none;\n      }\n    }\n  }\n\n  &-title {\n    &-wrapper {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      gap: 20px;\n      margin-top: 12px;\n\n      svg {\n        padding-left: 4px;\n        padding-top: 2px;\n      }\n    }\n  }\n\n  [class^='dist_tableBody'],\n  [class^='dist_tableHead'] {\n    grid-template-columns: 40px 320px minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) 285px;\n\n    .favoriteContainer {\n      display: none;\n    }\n\n    &:hover {\n      .favoriteContainer {\n        display: inherit;\n      }\n    }\n\n    .favoriteContainer.isActive,\n    .favoriteContainer:has(.FavoriteButton--isSaved) {\n      display: inherit;\n    }\n  }\n\n  [class^='dist_tableBody'] {\n    height: 64px;\n  }\n\n  .NumberWithVariationTableCell {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n  }\n\n  .NumberWithVariationTableCell-variation {\n    font-size: 10px;\n  }\n\n  .NumberWithVariationTableCell-variation-positive {\n    color: var(--success);\n  }\n\n  .NumberWithVariationTableCell-variation-negative {\n    color: var(--danger);\n  }\n\n  tr:hover {\n    .GenerateWinninAIReportButton-text {\n      align-items: center;\n      display: flex;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
